__turbopack_context__.v({
  "column": "Columns-module__0CMTVG__column",
  "grow": "Columns-module__0CMTVG__grow",
  "seg": "Columns-module__0CMTVG__seg",
  "sparse": "Columns-module__0CMTVG__sparse",
});
